import { render, staticRenderFns } from "./LocationModalData.vue?vue&type=template&id=5f8066c4&"
import script from "./LocationModalData.vue?vue&type=script&lang=js&"
export * from "./LocationModalData.vue?vue&type=script&lang=js&"
import style0 from "./LocationModalData.vue?vue&type=style&index=0&id=5f8066c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports